export const Role = {
  // Admin Roles
  ADMIN: 'admin',
  ADMIN_DEV: 'ADMIN_DEV',
  ADMIN_BUSINESS: 'ADMIN_BUSINESS',

  // Staff Roles
  STAFF_ACCOUNTING: 'STAFF_ACCOUNTING',
  STAFF_COURSE_MANAGER: 'STAFF_COURSE_MANAGER',
  STAFF_COURSE_MENTOR: 'STAFF_COURSE_MENTOR',
  STAFF_USER_SUPPORT: 'STAFF_USER_SUPPORT',

  // Default Role
  LEARNER: 'LEARNER'
};